import React from 'react';
import { Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { FiAlertCircle, FiCheck } from 'react-icons/fi';

// Estado do auto-save ao lado do campo. Sem isto o auditor não tem como saber se
// a nota chegou na API — "salva automaticamente" sem feedback dava falsa
// sensação de segurança (EG-44).
export default function SaveStatusHint({ status, onRetry }) {
 if (status === 'saving') {
  return (
   <Flex align='center' gap='1'>
    <Spinner size='xs' color='blue.400' />
    <Text fontSize='xs' color='#5C6066'>
     Salvando...
    </Text>
   </Flex>
  );
 }

 if (status === 'saved') {
  return (
   <Flex align='center' gap='1' color='green.600'>
    <FiCheck size={14} />
    <Text fontSize='xs'>Salvo</Text>
   </Flex>
  );
 }

 if (status === 'error') {
  return (
   <Flex align='center' gap='1' color='red.600'>
    <FiAlertCircle size={14} />
    <Text fontSize='xs'>Erro ao salvar</Text>
    <Button variant='link' size='xs' colorScheme='red' onClick={onRetry}>
     Tentar de novo
    </Button>
   </Flex>
  );
 }

 return (
  <Text fontSize='xs' color='#9CA0A6'>
   Salva automaticamente
  </Text>
 );
}
